module.exports = __webpack_public_path__ + "static/media/bookingSetsActive.7dc6f728.svg";